import React from 'react'

import SvgIcon from './SvgIcon'
import { LegacyMark } from './LegacyMark'

const ProviderAsButton = ({
    id,
    vendor,
    description,
    name,
    picture,
    active,
    pending,
    deletable,
    ready,
    onClick,
    showBolt,
}) => (
    <li
        className={`try-intento__choice-item try-intento__choice-item${
            active ? '--active' : '--not-active'
        }`}
        title={name}
        tabIndex="0"
        onKeyPress={onClick}
        onClick={onClick}
        role="button" // eslint-disable-line jsx-a11y/no-noninteractive-element-to-interactive-role
    >
        <div className="try-intento__choice-item-image">
            <img height="48" width="48" src={`/${picture}`} alt="Logo" />
        </div>
        <div className="try-intento__choice-item-content">
            <div className="try-intento__choice-item-title">
                {vendor}
                <LegacyMark providerId={id} />
            </div>
            <div className="try-intento__choice-item-text">{description}</div>
        </div>
        {pending && (
            <div className="try-intento__choice-item-icon">
                <div className="loader">
                    <div className="spinner">
                        <SvgIcon slug="spinner" />
                    </div>
                </div>
            </div>
        )}
        {!pending && deletable && (
            <div className="try-intento__choice-item-icon">
                <SvgIcon slug="cross" />
            </div>
        )}
        {ready && (
            <div className="try-intento__choice-item-icon">
                <SvgIcon slug="tick-2" />
            </div>
        )}
        {showBolt && (
            <div
                className="try-intento__choice-item-capability"
                title="Integrated"
            >
                <SvgIcon slug="bolt" />
            </div>
        )}
    </li>
)

export default ProviderAsButton



// WEBPACK FOOTER //
// /usr/src/app/frontend/src/components/ProviderAsButton.jsx